// Lista centralizada de roles de usuario.
// "gerente" y "gerente_calidad" están fijos a una sola unidad (campo `unidad`
// en usuarios_autorizados / usuarios). "supervisor_tiendas" puede tener varias
// unidades asignadas (campo `unidades`, array). "dueno" y "admin" no tienen
// restricción de unidad.

export const ROLES = [
  { id: "dueno", nombre: "Dueño", multiUnidad: false, sinUnidad: true },
  { id: "admin", nombre: "Coordinador de Administración", multiUnidad: false, sinUnidad: true },
  { id: "gerente", nombre: "Gerente de Tienda", multiUnidad: false, sinUnidad: false },
  { id: "gerente_calidad", nombre: "Gerente de Higiene y Calidad", multiUnidad: false, sinUnidad: false },
  { id: "supervisor_tiendas", nombre: "Supervisor de Tiendas", multiUnidad: true, sinUnidad: false }
];

export function nombreDeRol(rolId) {
  return ROLES.find(r => r.id === rolId)?.nombre || rolId;
}

export function rolUsaMultiUnidad(rolId) {
  return ROLES.find(r => r.id === rolId)?.multiUnidad || false;
}
